import { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';


import CadastrosInternosService from '../../services/CadastrosInternosService';
import formCadastroUpdatePublicDTO from '../../types/FormCadastroPublicUpdateDTO';
import "./PublicPerfilForm.css";
import "../../App.css";

import logo from '../../assets/img/logo-header.png';
import perfil from '../../assets/icons/perfil.png';

export default function PublicPerfilForm({ onClose, onSucesso }) {
  const userId = localStorage.getItem("UserId");

  const [form, setForm] = useState({
    idCadastro: null,
    nome: "",
    nascimento: "",
    email: "",
    login: "",
    senha: "",
    confirmarSenha: "",
    celular: "",
    rua: "",
    numero: "",
    bairro: "",
    complemento: "",
    cep: "",
    cidade: "",
    uf: "",
  });


  const [retorno, setRetorno] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);

  const editando = true; 


  // == Dados do usuário logado ====================================
  useEffect(() => {
    async function carregarPerfil() {
      try {
      
        const dados = await CadastrosInternosService.getById(userId);

        setForm((prev) => ({
          ...prev,
          idCadastro: dados.IDCADASTRO ?? null,
          nome: dados.NOME ?? "",
          nascimento: dados.NASCIMENTO ?? "",
          email: dados.EMAIL ?? "",
          login: dados.LOGIN ?? "",
          celular: dados.CELULAR ?? "",
          rua: dados.RUA ?? "",
          numero: dados.NUMERO ?? "",
          bairro: dados.BAIRRO ?? "",
          complemento: dados.COMPLEMENTO ?? "",
          cep: dados.CEP ?? "",
          cidade: dados.CIDADE ?? "",
          uf: dados.uf ?? "",
        }));
      } catch (err) {
        console.error("Erro ao carregar perfil:", err);
      }
    }

    carregarPerfil();
  }, [userId]);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  }

  
  // ==  Consulta CEP (ViaCEP) ====================================
  async function buscarCep() {
    const cepLimpo = form.cep.replace(/\D/g, "");

    if (cepLimpo.length !== 8) {
      alert("CEP inválido. Digite 8 números.");
      //setRetorno({ tipo: "erro", mensagem: "CEP inválido. Digite 8 números." });
      return;
    }

    try {
      setBuscandoCep(true);
      const resposta = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);

      if (!resposta.ok) {
        alert("Erro ao consultar o CEP.");
        //setRetorno({ tipo: "erro", mensagem: "Erro ao consultar o CEP." });
        return;
      }

      const dados = await resposta.json();

      if (dados.erro) {
        alert("CEP não encontrado.");
        //setRetorno({ tipo: "erro", mensagem: "CEP não encontrado." });
        return;
      }

      setForm((prev) => ({
        ...prev,
        rua: dados.logradouro || "",
        bairro: dados.bairro || "",
        cidade: dados.localidade || "",
        uf: dados.uf || "",
      }));
    } catch (error) {
      setRetorno({ tipo: "erro", mensagem: "Erro ao consultar o CEP." });
    } finally {
      setBuscandoCep(false);
    }
  }

  // == Validação ====================================
  function validarCampos() {
    const newErrors = {};

    if (!form.nome.trim()) newErrors.nome = "Informe o nome";
    if (!form.email.trim()) newErrors.email = "Informe o e-mail";
    if (!form.login.trim()) newErrors.login = "Informe o login";
    if (!form.celular.trim()) newErrors.celular = "Informe o celular";

    return newErrors;
  }


  // == Atualiza Perfil ====================================
  async function handleSubmit(e) {
    e.preventDefault();

    const newErrors = validarCampos();
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    setLoading(true);
    setRetorno(null);

    try {
        const payload = formCadastroUpdatePublicDTO({
          nome: form.nome,
          nascimento: form.nascimento, 
          email: form.email, 
          login: form.login, 
          senha: form.senha, 
          celular: form.celular,
          rua: form.rua, 
          numero: Number(form.numero), 
          bairro: form.bairro, 
          complemento: form.complemento, 
          cep: form.cep, 
          cidade: form.cidade,
          uf: form.uf
        });
      delete payload.idCadastro;
      delete payload.confirmarSenha;

      await CadastrosInternosService.update(userId, payload);

      if (onSucesso) {
        onSucesso("Cadastro atualizado com sucesso!");
      }

    } catch (error) {

      console.error("Erro ao atualizar perfil:", error);

    } finally {
      setLoading(false);
    }
  }

  return (
      <div className="Perfil-form-Container">
        <div className="Perfil-form-Fechar" onClick={onClose}> X </div>

        <img src={logo} alt="Logotipo" className="Perfil-form-logo" />

        <div className="Perfil-form-title">
          <img src={perfil} alt="Perfil" className="icon" />
          Atualizar Cadastro
        </div>

        <div className="Perfil-form-linha"></div>

        {retorno && (
          <div
            className={
              retorno.tipo === "sucesso"
                ? "mensagem-sucesso"
                : "mensagem-erro"
            }
          >
            {retorno.mensagem}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="Perfil-form-alinhamento">
            <div className="Perfil-form-label">Nome: *</div>
            <input name="nome" value={form.nome} onChange={handleChange} />
            {errors.nome && <span style={{ color: "red" }}>{errors.nome}</span>}
          </div>

          <div className="Perfil-form-alinhamento">
            <div className="Perfil-form-label">Nascimento: *</div>
            <input type="date" name="nascimento" value={form.nascimento} onChange={handleChange} />
          </div>

          <div className="Perfil-form-alinhamento">
            <div className="Perfil-form-label">Email: *</div>
            <input name="email" value={form.email} onChange={handleChange} />
          </div>

          <div className="Perfil-form-alinhamento">
            <div className="Perfil-form-label">Login: *</div>
            <input name="login" value={form.login} onChange={handleChange} />
          </div>

          <div className="Perfil-form-alinhamento">
            <div className="Perfil-form-label">Senha: </div>
            <input type="password" name="senha" value={form.senha} onChange={handleChange} />
          </div>

          <div className="Perfil-form-alinhamento">
            <div className="Perfil-form-label">Celular: *</div>
            <input name="celular" value={form.celular} onChange={handleChange} />
          </div>

          <div className="Perfil-form-alinhamento-cep">
            <div className="Perfil-form-label">CEP:</div>

            <div style={{ display: "flex", gap: "10px", flexDirection: "row" }}>
              <input
                name="cep"
                value={form.cep}
                onChange={handleChange}
                maxLength={9}
                placeholder="00000-000"
                className="cep"
              />

              <button type="button" onClick={buscarCep} disabled={buscandoCep} >
                {buscandoCep ? "Buscando..." : "Buscar"}
              </button>
            </div>
          </div>

          <div className="Perfil-form-alinhamento">
            <div className="Perfil-form-label">Rua:</div>
            <input name="rua" value={form.rua} onChange={handleChange} />
          </div>

          <div className="Perfil-form-alinhamento">
            <div className="Perfil-form-label">Número:</div>
            <input name="numero" value={form.numero} onChange={handleChange} />
          </div>

          <div className="Perfil-form-alinhamento">
            <div className="Perfil-form-label">Bairro:</div>
            <input name="bairro" value={form.bairro} onChange={handleChange} />
          </div>

          <div className="Perfil-form-alinhamento">
            <div className="Perfil-form-label">Complemento:</div>
            <input name="complemento" value={form.complemento} onChange={handleChange} />
          </div>

          <div className="Perfil-form-alinhamento">
            <div className="Perfil-form-label">Cidade:</div>
            <input name="cidade" value={form.cidade} onChange={handleChange} />
          </div>

          <div className="Perfil-form-alinhamento">
            <div className="Perfil-form-label">UF:</div>
            <input name="uf" maxLength={2} value={form.uf} onChange={handleChange} />
          </div>

          <div className="Perfil-form-alinhamento-button">
            <button type="submit" disabled={loading}>
              {loading ? "Salvando..." : "Salvar Alterações"}
            </button>

            <button type="button" className="Perfil-button" onClick={onClose}>
              Voltar
            </button>
          </div>
        </form>
      </div>
  );
}
